import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const CursorChoose = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.666687 2.66666L2.66669 4.66666L6.66669 0.666656"
      fill="currentColor"
    />
    <path
      d="M0.666687 2.66666L2.66669 4.66666L6.66669 0.666656"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M10.6667 0.666656L15.3334 5.33332L10.6667 0.666656Z"
      fill="currentColor"
    />
    <path
      d="M10.6667 0.666656L15.3334 5.33332"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M15.3334 0.666656L10.6667 5.33332L15.3334 0.666656Z"
      fill="currentColor"
    />
    <path
      d="M15.3334 0.666656L10.6667 5.33332"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.1446 8.19526C7.2696 8.07026 7.4392 7.99999 7.616 7.99999C7.7928 7.99999 7.9624 8.07026 8.0874 8.19526C8.2124 8.32026 8.28267 8.48986 8.28267 8.66666V10.6667C8.28267 10.9192 8.42533 11.15 8.6512 11.2629L10.9493 12.412V16H12.2827V12C12.2827 11.7475 12.14 11.5167 11.9141 11.4037L9.616 10.2547V8.66666C9.616 8.13626 9.40527 7.62752 9.0302 7.25246C8.65513 6.87739 8.1464 6.66666 7.616 6.66666C7.08553 6.66666 6.57685 6.87739 6.20178 7.25246C5.82671 7.62752 5.61599 8.13619 5.61599 8.66666V11.4227L5.39385 11.2749L5.39243 11.2739C5.04173 11.042 4.61941 10.9437 4.20233 10.9969C3.78526 11.0501 3.40116 11.2514 3.11996 11.5639C2.83876 11.8765 2.67916 12.2797 2.6702 12.7001C2.66124 13.1205 2.80353 13.5301 3.07115 13.8543L3.07319 13.8568L4.85927 16H6.5949L4.09951 13.0057L4.09873 13.0047C4.03497 12.927 4.00109 12.829 4.00323 12.7285C4.00538 12.6275 4.04371 12.5307 4.11123 12.4557C4.17875 12.3806 4.27098 12.3323 4.37113 12.3195C4.47106 12.3068 4.57224 12.3303 4.65634 12.3857L4.65689 12.3861L5.91347 13.2218C6.11808 13.3579 6.38097 13.3703 6.59756 13.2543C6.81413 13.1382 6.94933 12.9124 6.94933 12.6667V8.66666C6.94933 8.48986 7.0196 8.32026 7.1446 8.19526Z"
      fill="currentColor"
    />
  </svg>,
  'CursorChoose'
);
